import GeoPoint from "@/models/Shared/GeoPoint";

export default class BranchSummaryDto {
    brandName = '';
    emailAddress = '';
    phoneNumber = '';
    registrationNumber = '';
    fullAddress = '';
    geometry: GeoPoint = new GeoPoint();
    isExactGeo: boolean;
}
